import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "antd";
import Hexapi from "../../utility/HexAPI/Hexapi";
import FileIcon from "../../utility/Attach_doc/file.png";
import { ViewComponent } from "./ViewComponent";

const MultiAttachmentviewer = (props) => {
  const [docs, setAttachmentList] = useState([]);
  const [attachmentid,setattachmentid]=useState("")
  const [attachmentshow,setattachmentshow]=useState(false)
  const attachments = useMemo(() => {
    return props?.passid
      ? props.passid.split(",").map((id) => id.trim()).filter(Boolean)
      : [];
  }, [props?.passid]);

  const attachmentifo = async () => {
    try {
      const obj = {
        query: `HRApp_Droid_Proc_User_GetAttachmentInfo @AttachmentIds='{0}',@UserID='{1}'`,
        queryArr: [`${props?.passid}`, `${props?.userid}`],
      };

      const resp = await Hexapi(obj);

      if (resp && resp[""]?.length > 0) {
        setAttachmentList(resp[""]);
      } else {
        setAttachmentList([]);
      }
    } catch (error) {
      console.log(error);
      setAttachmentList([]);
    }
  };

  useEffect(() => {
    if (attachments.length > 1) {
      attachmentifo();
    } else {
      setAttachmentList([]);
    }
  }, [props?.passid, props?.userid]);


  const getAttachmnetId=(id)=>{
    setattachmentid(id)
    setattachmentshow(true)
  }
  return (
    <>

    {
        attachments.length == 1 ? <ViewComponent passid={props?.passid}
                      userid={props.userid}
                      isFileALlowDownload={props.isFileALlowDownload}
                      isViewModalOpen={() => props?.isViewModalOpen}
                      closeModal={() =>
                        props.closeModal()
                      }
                      disablewatermark={props?.disablewatermark}
                      approvalempname={props.approvalempname}/>:<Modal
        title="Attachments"
        open={props?.isViewModalOpen}
        onCancel={() => props.closeModal()}
        footer={null}
        width={700}
        centered
      >
    
        <div className="row">
          {docs.map((doc) => (
            <div
            onClick={()=>getAttachmnetId(doc.attachmentid)}
              className="col-md-2"
              key={doc.attachmentid}
              style={{
                padding: "10px 10px",
                paddingLeft:"0px",
                paddingRight:"0px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="multidocdiv">
                <div className="main">
                  <img src={FileIcon} alt="file" />
                  <span>.{doc.extension}</span>
                </div>

                <div className="bottom">
                  <span className="docname">{doc.filename}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal>
    }
      
      {
        (attachmentshow && attachmentid) && <ViewComponent passid={attachmentid}
                      userid={props.userid}
                      isFileALlowDownload={props.isFileALlowDownload}
                      isViewModalOpen={() => attachmentshow}
                      closeModal={() =>
                       setattachmentshow(false)
                      }
                      disablewatermark={props?.disablewatermark}
                      approvalempname={props.approvalempname}/>
      }
    </>
  );
};
export default MultiAttachmentviewer;